import React, { useState, Component } from 'react';
import axios from 'axios';
import { Button, Form } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import { Redirect } from "react-router-dom";
import "./login.css";
import 'react-toastify/dist/ReactToastify.css';
import metaData from "../../metaData"
import LoginRedirect from '../../LoginRedirect';
let email;
let login = metaData[0].login;
export let loginDetails;

toast.configure({
    autoClose: 16000,
    draggable: false,
    //etc you get the idea
});

export default class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: "",
            showmailError: false,
            loginText:"Login"
        }
    }

    emailChange(e) {
        email = e.target.value;
        this.setState({
            email: email
        })
    }
    passwordChange(e) {
        this.setState({
            password: e.target.value
        })
    }

    login(e) {
        login.params.username=this.state.email;
        login.params.password=this.state.password;

        this.setState({
          loginText:"Loading..."
        })

        axios.post(login.url, {
                username:this.state.email,
                password:this.state.password
          },{headers: {
            'Content-Type': 'application/json',
        'x-zippr-api-key': '1e1352a39ebd3db612cc233e8519bee7f36ca655c43e6cf1783e58c1b31a2d7c',

        }}).then(res => {
          console.log(res.data, "login res+++");
              if(res.data.ok){
                window.user_type=res.data.response.user.user_type;
                window.workOrder=res.data.response.user.workOrder;
                window.sessionToken=res.data.response['x-zippr-sessiontoken'];


                let response=res.data.response;
                if(response.subscriptions){
                  delete response.subscriptions
                }
                if(response.personal_zipprs){
                  delete response.personal_zipprs
                }
                this.setState({
                  loginText:"Login"
                })
                localStorage.setItem("loginDetails", JSON.stringify(res.data.response));
                localStorage.setItem("loginDetails", JSON.stringify(res.data.response));
                window.loginDetails = JSON.stringify(res.data.response);
                toast.success("Success!", {
                    position: toast.POSITION.TOP_RIGHT
                });
                 loginDetails=res.data.response;
                 console.log(res.data.response, "res.data.responseloginn");

                 if(loginDetails.user.user_type!=='admin' && loginDetails.user.workOrder){

                   let workorderArr=loginDetails.user.workOrder.split(",");
                   if(workorderArr.length==1){
                     console.log(workorderArr[0],"workorderro....");
                     axios
                       .get(metaData[0].workorderDetails.url, {
                         params: { work_order: workorderArr[0] },
                         headers: metaData[0].headers
                       })
                       .then(res => {
                         if(res.data.ok){
                         console.log(res.data.response.workOrderObj, "ooiiigg");
                         let response = res.data.response.workOrderObj;
                         let type = "creation";
                         localStorage.setItem("workOrderObj", JSON.stringify(response));
                         localStorage.setItem("type", JSON.stringify(type));

                         this.props.history.push('/selectWorkOrder');
                           // window.location.reload();
                         }else{
                           toast.error("Error while getting workorder details", {
                               position: toast.POSITION.TOP_RIGHT
                           });
                         }
                       }).catch(err => {
                        this.props.history.push('/selectWorkOrder');
                       })
                   }else if(workorderArr.length>1){
                     this.props.history.push('/selectWorkOrder');
                   }
                 }else{
                   this.props.history.push('/selectWorkOrder');
                 }

              }else{
                toast.error("Error :( !", {
                    position: toast.POSITION.TOP_RIGHT
                });
              }
            })
            .catch(err=>{
              console.log(err,"errerr");
              this.setState({
                loginText:"Login"
              })
                toast.error(err+"Error :(", {
                    position: toast.POSITION.TOP_RIGHT
                });
            })

      //  window.location.reload();
    }
    onBlurEmail(e) {
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
            //alert(this.state.email);
            this.setState({
                showmailError: false
            })
        } else {
            this.setState({
                showmailError: true
            })
        }
    }

    render() {

        return (
          <LoginRedirect>
            <div className="center">

                <div class="toast" role="alert" aria-live="assertive" aria-atomic="false" animation='true'>
                    <div class="toast-header">
                        <img src="" class="rounded mr-2" alt="..." />
                        <strong class="mr-auto">Bootstrap</strong>
                        <small class="text-muted">just now</small>
                        <button type="button" class="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="toast-body">
                        See? Just like this.
  </div>
                </div>

                <div className='row'>
                    <ToastContainer />
                    <div className="col-md-4"></div>
                    <div className='col-md-4 login-form'>
                        <h3 className='login-title'>Log In to DDN Dashboard</h3>
                        {/* <form> */}
                            <span className='input-box'><span className="glyphicon glyphicon-user" /> <input className="email" onChange={this.emailChange.bind(this)} onBlur={this.onBlurEmail.bind(this)} type="text" placeholder="Enter Your Email" /> </span>
                            {this.state.showmailError ? <span className="glyphicon glyphicon-exclamation-sign email-validate-symbol" data-toggle="tooltip" data-placement="top" title="Invalid email"></span> : ""}
                            <br />
                            <br />
                            <span className='input-box'> <span className="glyphicon glyphicon-lock" />  <input className="password" type="password" placeholder="Enter Your Password" onChange={this.passwordChange.bind(this)} /></span> <br /><br />
                            <button className='login-button' onClick={this.login.bind(this)}>
                                <span className='glyphicon glyphicon-log-in login-icon'></span> {this.state.loginText}
                 </button>
                        {/* </form> */}
                    </div>
                    <div className="col-md-4"></div>
                </div>
            </div>
          </LoginRedirect>
        )
    }

}
